import { FormInput, validateCurrency } from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { Field, FormSection } from 'redux-form'
import { Grid } from 'semantic-ui-react'

const i18nkey = 'admin.product.specialitems.'

const mapStateToProps = undefined

const mapDispatchToProps = undefined

class ProductSpecialItems extends React.Component {
  render() {
    const { specialStockChanges = {} } = this.props
    return (
      <Field
        name="specialStock"
        component={({ input: { value } }) => {
          return (
            <Grid
              children={[
                <Grid.Row key="header">
                  <Grid.Column width={2} textAlign="right">
                    Gruppe
                  </Grid.Column>
                  <Grid.Column width={1} textAlign="center">
                    Anzahl
                  </Grid.Column>
                  <Grid.Column width={1} textAlign="center">
                    Preis
                  </Grid.Column>
                  <Grid.Column width={4} textAlign="center">
                    Beschreibung DE
                  </Grid.Column>
                  <Grid.Column width={4} textAlign="center">
                    Beschreibung FR
                  </Grid.Column>
                </Grid.Row>,
                ...Object.keys(value).map((key) => (
                  <FormSection key={key} name={'specialStock.' + key}>
                    <Grid.Row>
                      <Grid.Column
                        width={2}
                        textAlign="right"
                        children={I18n.t(i18nkey + key)}
                      />
                      <Grid.Column width={1}>
                        <Field name="quantity" component={FormInput} readOnly className={specialStockChanges[key] && 'changed'}/>
                      </Grid.Column>
                      <Grid.Column width={1}>
                        <Field name="price" noErrorText component={FormInput} validate={validateCurrency}/>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Field name="description_de" component={FormInput}/>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Field name="description_fr" component={FormInput}/>
                      </Grid.Column>
                    </Grid.Row>
                  </FormSection>
                )),
              ]}
            />
          )
        }}
      />
    )
  }
}

ProductSpecialItems = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductSpecialItems)
export default ProductSpecialItems



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductSpecialItems.jsx